// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"xba-z"};